export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "ここにテキストを入力してください",
      conversationalPlaceholder: "ここに回答を入力してください",
      conversationClosed: "会話が終了しました。",
      conversationalDisclaimer: "フォローアップの質問は、あなたの回答に基づいてAIによって生成されます。"
    },
    openText: {
      openEndPlaceholder: "ここにテキストを入力してください"
    },
    multiText: {
      fieldPlaceholder: '回答 {number}',
      instruction: '下に少なくとも {count} 個の回答を、テキストボックスごとに 1 つずつ入力してください',
      instructionWithoutMinimum: '下に回答を、テキストボックスごとに 1 つずつ入力してください',
      minimumEntries: '次に進むには、回答を少なくとも {count} 個入力してください。',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'ブランド {number}',
        minimumEntries: '次に進むには、ブランドを少なくとも {count} 個入力してください。'
      }
    },
    multiselect: {
      caption: "該当するものをすべて選択してください"
    },
    rankOrder: {
      enterRankOrder: "順位を入力してください",
      placeholder: "ここに選択肢をドラッグして並べ替えてください"
    },
    openNumeric: {
      label: "数値入力"
    },
    complete: {
      message: "アンケートにご協力いただきありがとうございます。"
    },
    openVideo: {
      warning: "続行する前に動画を録画してください。",
      uploadStatusUploading: "続行する前に、動画の処理が完了するまでお待ちください...",
      uploadStatusSuccess: "アップロードが完了しました。続行できます。",
      uploadStatusError: "アップロードが完了しませんでした。もう一度お試しください。"
    }
  },
  errors: {
    node: {
      text_invalid_email: '有効なメールアドレスを入力してください',
      text_invalid_phone: '有効な電話番号を入力してください',
      text_invalid_us_zip: '有効なアメリカの郵便番号（ZIP）を入力してください',
      text_invalid_ca_postal: '有効なカナダの郵便番号を入力してください',
      text_invalid_uk_postal: '有効な英国の郵便番号を入力してください',
      text_invalid_custom: '有効な{fieldName}を入力してください',
      text_min_chars: '{min}文字以上入力してください',
      text_max_chars: '{max}文字以内で入力してください',
      text_alpha_not_allowed: '数字のみ入力できます',
      text_numeric_not_allowed: 'アルファベットのみ入力できます'
    },
    external: {
      invalid: 'この質問への回答は無効です。',
      required: 'この質問への回答は必須です。',
      singlechoice_required: '次に進む前に、オプションを選択してください。',
      numeric_required: '次に進む前に、評価を選択してください。',
      text_required: '次に進む前に、回答を入力してください。',
      bigtext_required: '次に進む前に、回答を入力してください。',
      singlechoiceother_incomplete: '次に進む前に、回答を入力してください。',
      multiselectother_incomplete: '次に進む前に、回答を入力してください。',
      numeric_invalid: '次に進む前に、有効な数字を入力してください。',
      radiogrid_required: '次に進む前に、各行のオプションを選択してください。',
      incomplete: '続行する前に、この質問を完了させてください。',
      multiselect_min: '次に進む前に、少なくとも {value} 個のオプションを選択してください。',
      multiselect_max: '次に進む前に、選択できるオプションは {value} 個以下にしてください。',
      multiselectother_min: '次に進む前に、少なくとも {value} 個のオプションを選択してください。',
      multiselectother_max: '次に進む前に、選択できるオプションは {value} 個以下にしてください。',
      multiselectgrid_min: '次に進む前に、各行で少なくとも {value} 個のオプションを選択してください。',
      multiselectgrid_max: '次に進む前に、各行で選択できるオプションは {value} 個以下にしてください。',
      rankorder_min: '次に進む前に、少なくとも {value} 個の項目にランク付けしてください。',
      rankorder_max: '次に進む前に、ランク付けできる項目は {value} 個以下にしてください。'
    }
  }
}
